import { useMutation } from "@shared/lib/hooks";
import { useQueryClient } from "@tanstack/react-query";
import { AccountingService } from "../services/Accounting.service";
import { ICreatePayment, PAYMENT_QUERY_KEY } from "../types";

export function useCreatePayment() {
  const queryClient = useQueryClient();
  const {
    mutate: createPayment,
    isLoading: isCreating,
    isSuccess: isCreated,
    error: createPaymentError,
  } = useMutation({
    mutationFn: (data: ICreatePayment) => AccountingService.createPayment(data),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...PAYMENT_QUERY_KEY],
      });
      // queryClient.invalidateQueries({
      //   queryKey: [ACCOUNTING_QUERY_KEYS],
      // });
    },
  });

  return { createPayment, isCreating, isCreated, createPaymentError };
}
